import React, { useMemo } from 'react';

import DataDetailsSection from '../../../../../../components/DataDetailsSection';

// hooks
import { useConfigContext } from '../../../../../Config/hooks/useConfig';
import { useIdentityDocumentType } from '../../../../hooks/useIdentityDocumentType';

import {
  IDENTITY_DOCUMENT_TYPE,
  SHARED_SECRET_TYPE,
  MAP_RECIPIENT_FIELD_NAMES,
} from '../../../../../../constraints';

// formatters
import { userInfoFormatter } from '../../../../../../formatters';
import * as formatters from '../../../../../Users/formatters';
import {
  recipientGdprSuspendedFormatter,
  recipientStatusWithToolTipFormatter,
  recipientSharedSecretTypeFormatter,
} from '../../../../formatters';
import { blurSingleFormatter } from '../../../../../../formatters';

const DetailsSection = ({ recipient = {} }) => {
  const { isDefault, recipientsConfig } = useConfigContext();
  const { isFullName, isSharedSecretOptional } = recipientsConfig || {};
  const { getIdentityDocumentTypeText } = useIdentityDocumentType();
  const { documentType, sharedSecret } = recipient || {};

  const externalIdText = useMemo(
    () => getIdentityDocumentTypeText(documentType),
    [documentType],
  );

  const genericEnabledDetailsCol1 = [
    {
      title: externalIdText,
      data: blurSingleFormatter(
        recipient?.documentNumber,
        isDefault && documentType === IDENTITY_DOCUMENT_TYPE.PESEL,
      ),
      enabled: true,
    },
    {
      title: 'Status',
      data: recipientStatusWithToolTipFormatter(recipient?.status, recipient),
      enabled: true,
    },
    {
      title: MAP_RECIPIENT_FIELD_NAMES.SHARED_SECRET_TYPE,
      data: recipientSharedSecretTypeFormatter(
        sharedSecret?.type,
        isSharedSecretOptional,
      ),
      enabled: !!sharedSecret?.type || isSharedSecretOptional,
    },
    {
      title: `Verification - ${sharedSecret?.type}`,
      data: sharedSecret?.value,
      enabled:
        !!sharedSecret?.type &&
        ![SHARED_SECRET_TYPE.PESEL, SHARED_SECRET_TYPE.NONE].includes(
          sharedSecret.type,
        ),
    },
    {
      title: 'Payer Number',
      data: recipient?.payerNumbers?.join(', '),
      enabled: recipient?.payerNumbers?.length > 0,
    },
    {
      title: 'PPE Number',
      data: recipient?.ppeNumbers?.join(', '),
      enabled: recipient?.ppeNumbers?.length > 0,
    },
  ];

  const enabledDetailsCol1 = isFullName
    ? [
        {
          title: 'Name and surname',
          data: recipient?.name,
          enabled: true,
        },
        ...genericEnabledDetailsCol1,
      ]
    : [
        {
          title: 'First name',
          data: recipient?.firstName,
          enabled: true,
        },
        {
          title: 'Last name',
          data: recipient?.lastName,
          enabled: true,
        },
        ...genericEnabledDetailsCol1,
      ];

  const enabledDetailsCol2 = [
    {
      title: 'Email',
      data: recipient?.email,
      enabled: true,
    },
    {
      title: 'Phone number',
      data: recipient?.phoneNumber,
      enabled: true,
    },
    {
      title: 'Data processing suspension',
      data: recipientGdprSuspendedFormatter(recipient?.isGdprSuspended),
      enabled: true,
      warning: true,
    },
  ];

  const enabledDetailsCol3 = [
    {
      title: 'Created at',
      data: formatters.createdAtFormatter('', recipient),
      enabled: true,
    },
    {
      title: 'Created by',
      data: recipient?.createdBy
        ? userInfoFormatter('', recipient.createdBy)
        : '',
      enabled: true,
    },
  ];

  return (
    <DataDetailsSection
      headerMessageId={'Details'}
      activityTagEnabled
      isActive={recipient?.isActive}
      columns={[enabledDetailsCol1, enabledDetailsCol2, enabledDetailsCol3]}
    />
  );
};

export default DetailsSection;
